import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

function modalWrapperClasses(): string {
    return buildCssClassName([
        "h-screen",
        "w-screen",
        "bg-black/25",
        "backdrop-blur-sm",
        "fixed",
        "top-0",
        "left-0",
        "flex",
        "items-center",
        "justify-center",
        "transition-opacity",
        "duration-500",
        "transform",
        "scale-0",
        "pointer-events-auto",
        "opacity-100",
        "scale-100",
        "z-[200]"
    ])
}

export { modalWrapperClasses }

export default {
    modalWrapper: modalWrapperClasses,
    modalBody: (isShown: boolean): string =>
        buildCssClassName(
            "relative bg-white transform scale-50 h-fit",
            isShown && "!scale-100 z-[10001]",
            getTransitionTwClasses("all", 400)
        ),
    modalContent: (): string => "overflow-y-auto no-scrollbar",
    modalHeader: (isSticky: boolean): string =>
        buildCssClassName(isSticky ? "sticky h-fit z-[119] top-[0px] bg-white" : "relative"),
    closeBtn: (): string =>
        buildCssClassName(
            [
                "focus:!outline-[1px]",
                "focus:!outline",
                "focus:!outline-gray-23",
                "hover:!outline-[1px]",
                "hover:!outline",
                "hover:!outline-gray-23",
                "z-[10]",
                "fixed",
                "top-[10px]",
                "lg:top-[15px]",
                "right-[10px]",
                "lg:right-[15px]"
            ],
            getTransitionTwClasses("all", 150)
        )
}
